import { createIcon } from '../utils';

export const SparklesIcon = createIcon(
  ({ ref, className, width, height, ...rest }) => (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_5971_138845)">
        <path
          d="M2.99998 14.6693V11.3359M2.99998 4.66927V1.33594M1.33331 3.0026H4.66665M1.33331 13.0026H4.66665M8.66665 2.0026L7.51053 5.00851C7.32252 5.49733 7.22852 5.74174 7.08233 5.94733C6.95277 6.12954 6.79358 6.28873 6.61137 6.41829C6.40578 6.56447 6.16137 6.65848 5.67255 6.84649L2.66665 8.0026L5.67256 9.15872C6.16137 9.34673 6.40578 9.44073 6.61137 9.58692C6.79358 9.71648 6.95277 9.87567 7.08233 10.0579C7.22852 10.2635 7.32252 10.5079 7.51053 10.9967L8.66665 14.0026L9.82277 10.9967C10.0108 10.5079 10.1048 10.2635 10.251 10.0579C10.3805 9.87567 10.5397 9.71648 10.7219 9.58692C10.9275 9.44073 11.1719 9.34673 11.6607 9.15872L14.6666 8.0026L11.6607 6.84648C11.1719 6.65848 10.9275 6.56447 10.7219 6.41829C10.5397 6.28873 10.3805 6.12954 10.251 5.94733C10.1048 5.74174 10.0108 5.49733 9.82276 5.00851L8.66665 2.0026Z"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5971_138845">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  { displayName: 'SparklesIcon' },
);
